const sleepLabContent = globalThis.SLEEP_LAB_CONTENT;

const normalise = (value) => String(value ?? "")
  .toLowerCase()
  .normalize("NFKD")
  .replace(/[\u0300-\u036f]/g, "")
  .trim()
  .replace(/\s+/g, " ");

const rootPath = document.documentElement.dataset.rootPath || ".";
const localHubHref = (hub) => hub.url;
const localArticleHref = (article) => article.url;

const searchItems = sleepLabContent
  ? Object.freeze([
      ...sleepLabContent.hubs.map((hub) => ({
        title: hub.name,
        category: "Sleep Lab topic",
        type: `${hub.articleCount} guides`,
        href: localHubHref(hub),
        terms: `${hub.name} ${hub.description} ${hub.seo.focusKeyword}`,
      })),
      ...sleepLabContent.articles.map((article) => ({
        title: article.title,
        category: article.category,
        // Interne taxonomie (LANDING, GUIDE/DOWNLOAD, HUB) → lezerslabel.
        type: /download|checklist/i.test(article.pageType) ? "Guide + checklist" : /hub/i.test(article.pageType) ? "Topic overview" : "Guide",
        href: localArticleHref(article),
        terms: article.searchText,
      })),
    ])
  : Object.freeze([]);

document.querySelectorAll("[data-search-root]").forEach((root, rootIndex) => {
  const form = root.querySelector("[data-search-form]");
  const input = root.querySelector("[data-search-input]");
  const panel = root.querySelector("[data-search-panel]");
  const results = root.querySelector("[data-search-results]");
  const status = root.querySelector("[data-search-status]");
  const empty = root.querySelector("[data-search-empty]");

  if (!form || !input || !panel || !results || !status || !empty) return;

  let matches = [];
  let activeIndex = -1;

  const openPanel = () => {
    panel.hidden = false;
    input.setAttribute("aria-expanded", "true");
  };

  const closePanel = () => {
    panel.hidden = true;
    input.setAttribute("aria-expanded", "false");
    input.removeAttribute("aria-activedescendant");
    activeIndex = -1;
  };

  const setActive = (nextIndex, moveFocus = false) => {
    const options = Array.from(results.querySelectorAll("li"));
    if (!options.length) {
      activeIndex = -1;
      input.removeAttribute("aria-activedescendant");
      return;
    }
    activeIndex = (nextIndex + options.length) % options.length;
    options.forEach((option, optionIndex) => {
      option.dataset.active = optionIndex === activeIndex ? "true" : "false";
    });
    const activeLink = options[activeIndex].querySelector("a");
    input.removeAttribute("aria-activedescendant");
    if (moveFocus) activeLink?.focus({ preventScroll: true });
    options[activeIndex].scrollIntoView({ block: "nearest" });
  };

  const createResult = (item, itemIndex) => {
    const option = document.createElement("li");
    option.id = `search-option-${rootIndex}-${itemIndex}`;
    option.dataset.active = "false";

    const link = document.createElement("a");
    link.className = "search-result";
    link.href = item.href;

    const text = document.createElement("span");
    const title = document.createElement("span");
    const meta = document.createElement("span");
    const type = document.createElement("span");
    title.className = "search-result__title";
    title.textContent = item.title;
    meta.className = "search-result__meta";
    meta.textContent = item.category;
    type.className = "search-result__type";
    type.textContent = item.type;
    text.append(title, meta);
    link.append(text, type);
    option.append(link);
    option.addEventListener("pointerenter", () => setActive(itemIndex));
    return option;
  };

  const render = (rawQuery) => {
    const query = normalise(rawQuery);
    results.replaceChildren();
    empty.hidden = true;
    activeIndex = -1;
    input.removeAttribute("aria-activedescendant");
    if (!query) {
      closePanel();
      return;
    }

    const queryTerms = query.split(" ");
    matches = searchItems
      .map((item) => {
        const haystack = normalise(`${item.title} ${item.category} ${item.type} ${item.terms}`);
        const score = queryTerms.reduce((sum, term) => sum + (haystack.includes(term) ? 1 : 0), 0);
        return { item, score, titleMatch: normalise(item.title).includes(query) };
      })
      .filter((candidate) => candidate.score === queryTerms.length)
      .sort((left, right) => Number(right.titleMatch) - Number(left.titleMatch) || left.item.title.localeCompare(right.item.title))
      .slice(0, 8)
      .map((candidate) => candidate.item);

    openPanel();
    if (!matches.length) {
      status.textContent = `No results for “${rawQuery.trim()}”.`;
      empty.hidden = false;
      return;
    }
    status.textContent = `${matches.length} ${matches.length === 1 ? "result" : "results"} for “${rawQuery.trim()}”.`;
    matches.forEach((item, itemIndex) => results.append(createResult(item, itemIndex)));
  };

  input.addEventListener("input", () => render(input.value));
  input.addEventListener("focus", () => {
    if (input.value.trim()) render(input.value);
  });
  input.addEventListener("keydown", (event) => {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      if (panel.hidden && input.value.trim()) render(input.value);
      setActive(activeIndex + 1, true);
    }
    if (event.key === "ArrowUp") {
      event.preventDefault();
      if (panel.hidden && input.value.trim()) render(input.value);
      setActive(activeIndex - 1, true);
    }
    if (event.key === "Enter" && activeIndex >= 0 && matches[activeIndex]) {
      event.preventDefault();
      window.location.assign(matches[activeIndex].href);
    }
    if (event.key === "Escape") closePanel();
  });
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const query = input.value.trim();
    if (!query) {
      openPanel();
      results.replaceChildren();
      empty.hidden = false;
      status.textContent = "Enter a topic, question or sleep term to search.";
      return;
    }
    render(query);
    if (matches.length) window.location.assign(matches[0].href);
  });
  results.addEventListener("keydown", (event) => {
    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActive(activeIndex + 1, true);
    }
    if (event.key === "ArrowUp") {
      event.preventDefault();
      setActive(activeIndex - 1, true);
    }
    if (event.key === "Escape") {
      event.preventDefault();
      closePanel();
      input.focus();
    }
  });
  document.addEventListener("pointerdown", (event) => {
    if (!root.contains(event.target)) closePanel();
  });
});

document.querySelectorAll("[data-feedback]").forEach((feedback) => {
  const buttons = Array.from(feedback.querySelectorAll("[data-feedback-value]"));
  const status = feedback.querySelector("[data-feedback-status]");
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((item) => item.setAttribute("aria-pressed", item === button ? "true" : "false"));
      if (status) status.textContent = "Thanks. This local prototype does not send or store feedback.";
    });
  });
});

document.querySelectorAll("[data-current-year]").forEach((element) => {
  element.textContent = String(new Date().getFullYear());
});

document.querySelectorAll("details.mobile-nav").forEach((menu) => {
  const summary = menu.querySelector("summary");
  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => { menu.open = false; });
  });
  document.addEventListener("pointerdown", (event) => {
    if (menu.open && !menu.contains(event.target)) menu.open = false;
  });
  menu.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || !menu.open) return;
    event.preventDefault();
    menu.open = false;
    summary?.focus();
  });
});
